/** @format */

//importing components
import DynamicTable from "../../components/global/DynamicTable";
//import components
import HeadTitle from "../../components/global/HeadTitle";

//import table data
import { tableColumnDrivers } from "../../components/table/col-data";
import { useEffect, useState } from "react";
import Table from "../../components/Table2";
import { DriversColumns } from "../../constant/table";
import NavbarAndSidebar from "../../components/NavbarAndSidebar";
import AddManger from "../../components/pops/mangers/AddManger";
import { useDispatch, useSelector } from "react-redux";
import { getAllDrivers } from "../../store/drivers";
import drivers from "../../store/drivers";
import { Spinner1 } from "../../components/spinners/Spinner1";
import Pagination from "../../components/Pagination";
import AddDriver from "../../components/pops/driver/addDriver";

const Drivers = () => {
  const [isOpen, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { allDrivers, loading } = useSelector((state) => state.drivers);
  const render = useSelector((state) => state.toggleState.value.render);
  // const [allDrivers, setAllDrivers] = useState([]);

  useEffect(() => {
    dispatch(getAllDrivers("/drivers?page=1")).then((res) => {
      // setAllDrivers(res.payload.data?.data);
    });
  }, [dispatch, render]);

  const getPageData = (num) => {
    dispatch(getAllDrivers("/drivers" + "?page=" + num));
  };

  return (
    <NavbarAndSidebar>
      {loading && <Spinner1 />}
      <AddDriver
        isOpen={isOpen}
        setOpen={setOpen}
        toggleModal={() => setOpen(false)}
      />
      <div className='flex-between'>
        <HeadTitle title='السائقين' />
        <button className='btn btn__primary' onClick={() => setOpen(true)}>
          اضافه كابتن{" "}
        </button>
      </div>
      <div className='mb__small' />
      <Table
        data={allDrivers?.data ?? []}
        header={DriversColumns}
        link='/drivers/driver-profile/'
        // getSearchValue={getSearchValue}
        // searchValues={searchValues}
        name='drivers'
      />{" "}
      {drivers.loading && <Spinner1 />}
      {allDrivers?.pagination?.totalPages > 1 ? (
        <Pagination
          pagination={allDrivers?.pagination}
          getPageData={getPageData}
        />
      ) : null}
    </NavbarAndSidebar>
  );
};
export default Drivers;
